import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'https://www.zytszkj.com/api/'
Vue.prototype.$http = axios

// 自动在请求头中添加 Bearer token（如果存在）
axios.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');
    config.headers = config.headers || {};
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

// 统一解包后端 ApiResult（兼容 PascalCase / camelCase）
function unwrapApiResult(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  const hasFlag = 'IsSuccess' in payload || 'isSuccess' in payload;
  const hasCode = 'ErrorCode' in payload || 'errorCode' in payload;
  const hasMsg = 'Message' in payload || 'message' in payload;
  if (!hasFlag || !hasCode || !hasMsg) return payload;

  const ok = 'IsSuccess' in payload ? payload.IsSuccess : payload.isSuccess;
  const msg = 'Message' in payload ? payload.Message : payload.message;
  if (!ok) {
    throw new Error(msg || '接口返回失败');
  }
  if ('Result' in payload) return payload.Result;
  if ('result' in payload) return payload.result;
  return undefined;
}

axios.interceptors.response.use(
  response => {
    try {
      response.data = unwrapApiResult(response.data);
      return response;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

// 图片服务器地址
Vue.prototype.imgserver = 'https://www.zytszkj.com/'
Vue.prototype.$img = function(path) {
  if (!path) return '';
  let url = String(path).trim();
  url = url.replace(/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?\//i, Vue.prototype.imgserver);
  if (/^https?:\/\//i.test(url)) return url;
  return Vue.prototype.imgserver.replace(/\/?$/, '/') + url.replace(/^\//, '');
};
// el-upload 不走 axios，上传地址与 baseURL 保持一致
Vue.prototype.$uploadAction = axios.defaults.baseURL.replace(/\/?$/, '/') + 'File/UploadingFormFile';
// 上传组件不走 axios 拦截器，统一取 Result
Vue.prototype.$uploadResult = function(response) {
  return unwrapApiResult(response);
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
